import React from "react";
import moment from "moment";

// export const checkPreviousPhasesCompleted = (currentPhase, paymentPhases) => {
//     const currentOrder = currentPhase?.order;
//     const previousPhases = paymentPhases.filter(p => p?.order < currentOrder);
//     const previousPhasesCompleted = previousPhases.filter(p => p?.phaseComplete);
//     return previousPhases?.length == previousPhasesCompleted?.length
//         ? true
//         : false;
// }

// Regra única de conclusão de fase: uma fase considera-se completa quando a falta for
// <= 50 €. Aplica-se a TODAS as fases (1 a 5). O checkbox `phaseComplete` deixou de ter
// efeito. Base por fase: toPayWithPercentage enquanto o valor base não for atingido,
// senão toPay (nas fases 1/2 as bases coincidem). Falta negativa (sobre-pagamento) => completa.
export const isPhaseCompleteByMissing = (p, thresholdRule = true) => {
    const base = showValuesWithPercentage(p) ? (p?.toPayWithPercentage || 0) : (p?.toPay || 0);
    const effectivePayed = (p?.payed || 0) + (p?.carryForward || 0);
    return thresholdRule ? (base - effectivePayed) <= 50 : (base - effectivePayed) <= 0;
};

export const checkPreviousPhasesCompleted = (currentPhase, paymentPhases) => {
    const currentOrder = currentPhase?.order;
    const previousPhases = paymentPhases.filter(p => p?.order < currentOrder);

    let completedPhases = 0;
    for (const p of previousPhases) {
        if (isPhaseCompleteByMissing(p)) {
            completedPhases++;
        }
    }

    return previousPhases?.length == completedPhases
        ? true
        : false;
}

export const hasMissingValuesWithPercentage = (currentPhase) => {
    const effectivePayed = (currentPhase?.payed || 0) + (currentPhase?.carryForward || 0);
    let missing = 0;
    if (currentPhase?.order === 3 || currentPhase?.order === 4) {
        missing = ((currentPhase?.toPayWithPercentage || 0) - effectivePayed);
    }
    return (missing > 0);
}

export const getPhaseDate = (currentPhase, paymentPhases, wedding, translate) => {
    // for total payment before wedding, we need to show the date of the last phase
    if (currentPhase?.order === paymentPhases?.length) {
        const weddingDate = moment.utc(wedding?.date);
        if (
            currentPhase?.paymentQuestion?.answer?.response &&
            currentPhase?.paymentQuestion?.answer?.response?.length > 0 &&
            currentPhase?.paymentQuestion?.answer?.response[0]?.id === '5e73626cdb92f62505cc70f6'
        ) {
            return weddingDate.subtract(1, 'day').format('DD/MM/YYYY');
        }
    }

    return currentPhase?.date ? `${translate('UNTIL_BIG')} ${moment.utc(currentPhase?.date).format('DD/MM/YYYY')}` : '';
}

export const getMissingValue = (currentPhase, withPercentage = null) => {
    const effectivePayed = (currentPhase?.payed || 0) + (currentPhase?.carryForward || 0);
    let missing = 0;
    if (currentPhase?.order === 3 || currentPhase?.order === 4) {
        let toPay;
        if (withPercentage === true) {
            toPay = currentPhase?.toPayWithPercentage;
        } else if (withPercentage === false) {
            toPay = currentPhase?.toPay;
        } else {
            toPay = showValuesWithPercentage(currentPhase) ? currentPhase?.toPayWithPercentage : currentPhase?.toPay;
        }
        missing = ((toPay || 0) - effectivePayed);
    } else {
        missing = ((currentPhase?.toPay || 0) - effectivePayed);
    }

    return missing >= 0
        ? missing
        : 0;
}

export const getMissingColor = (phase, hasMissing) => {
    if (!hasMissing) return 'inherit';
    if (phaseDatePassed(phase)) return 'red';
    if (lessThanFifteenDaysToGo(phase)) return 'orange';
    return 'inherit';
};

export const showValuesWithPercentage = (p) => {
    const withoutPercentage = p?.toPay || 0;
    const effectivePayed = (p?.payed || 0) + (p?.carryForward || 0);
    return effectivePayed < withoutPercentage;
};

export const lessThanFifteenDaysToGo = (phase) => {
    const today = moment().startOf('day');
    const phaseDate = moment(phase?.date).startOf('day');
    const daysDiff = phaseDate.diff(today, 'days');
    if (today.isSameOrAfter(phaseDate)) {
        return true;
    }

    return daysDiff <= 15;
};

export const phaseDatePassed = (phase) => {
    const today = moment().startOf('day');
    const phaseDate = moment(phase?.date).startOf('day');
    if (today.isSameOrAfter(phaseDate)) {
        return true;
    }
    return false;
};

export const renderBudgetNotes = (translate) => {
    return <div style={{ textAlign: 'justify' }}>{translate('BUDGET_PRICE_CHANGE_NOTES')}</div>;
};

export const renderBudgetPhase3And4Notes = (translate) => {
    return <div style={{ fontSize: '12px', lineHeight: 'normal', marginBottom: '10px', textAlign: 'justify' }}>{translate('BUDGET_PHASES_3_AND_4_PRICE_CHANGE_NOTES')}</div>;
};